/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['html body{height:auto}  html body #pylon-chat,   html body .PylonChat,   html body cookiebar,   html body hj-navbar,   html body notification-bar-client,   html body us-button,   html body us-widget{display:none!important}[_nghost-%COMP%]{display:block;width:100%;background:#fff;z-index:1e+26;overflow-x:hidden;overflow-y:auto}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2NsaWVudC9oYWNrLXJlc3VsdHMvaGFjay1yZXN1bHRzLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2NsaWVudC9oYWNrLXJlc3VsdHMvaGFjay1yZXN1bHRzLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./compiled/src/app/components/client/hack-results/hack-results.component.scss.shim.ngstyle.ts